export const mappingStatusTicket = (status?: string): string => {
  if (status === 'resolved') return 'closed'

  return status || ''
}
